module.exports = __webpack_public_path__ + "static/img/logo4.210bb9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo4.png
// module id = K1UE
// module chunks = 1